export default class Accordion {
  constructor(element) {
    this.element = element;
    this.containers = this.element.querySelectorAll('.js-accordion');
    this.options = {
      openDefault: false,
    };

    this.init();
  }

  init() {
    this.setOptions();

    for (let i = 0; i < this.containers.length; i++) {
      const container = this.containers[i];
      container.addEventListener('click', this.toggleAccordion.bind(this));

      if (this.options.openDefault) {
        container.classList.add('is-active');
      }
    }
  }

  toggleAccordion(element) {
    const target = element.currentTarget;
    const isActive = target.classList.contains('is-active');

    for (let i = 0; i < this.containers.length; i++) {
      const container = this.containers[i];
      container.classList.remove('is-active');
    }

    if (!isActive) {
      target.classList.add('is-active');
    }
  }

  setOptions() {
    if ('open' in this.element.dataset) {
      this.options.openDefault = true;
    }
  }
}
